
$(document).ready(function() {
    $('#slideLeft').on('click', function () {
        // alert('left')
        $('.fearure-tab').animate({
            scrollLeft: '-=50px',
        }) ;
        
    });
});
$(document).ready(function() {
    $('#slideRight').on('click', function() {
        // alert('right')
        $('.fearure-tab').animate({
            scrollLeft: '+=50px',
        }) ;
        
    });
});
// $(document).ready(function() {
//     // $('#slideRight').click(function () {
//     $('#slideRight').on('click', function() {
//         console.log('click right');
//         $('.fearure-tab').scrollLeft += 20;
//     });
// });


// WEBPACK FOOTER //
// ./scripts/modules/components/_portfolio-tag.js